(()=>{'use strict';
const C=window.SDPC;if(!C||C.cartReady)return;C.cartReady=true;
const{$,$$,R,esc,money,toast,openDrawer,drawer}=C;
const lineStates=new Map();

const injectControlStyles=()=>{
  if(document.getElementById('sdpc-cart-control-styles'))return;
  const style=document.createElement('style');
  style.id='sdpc-cart-control-styles';
  style.textContent='.sd-cart-line__quantity button{touch-action:manipulation;-webkit-tap-highlight-color:transparent;user-select:none;cursor:pointer;transition:transform .12s ease,opacity .12s ease}.sd-cart-line__quantity button:active{transform:scale(.88)}.sd-cart-line__quantity.is-updating [data-cart-quantity-value]{opacity:.72}.sd-cart-line.is-removing{opacity:.58;transition:opacity .15s ease}';
  document.head.appendChild(style);
};
injectControlStyles();

const fetchCart=async()=>{
  const r=await fetch(R.cartJson||'/cart.js',{headers:{Accept:'application/json'}});
  const j=await r.json();
  if(!r.ok)throw Error(j.description||'Cart could not be loaded.');
  return j;
};

const findLineRow=lineKey=>$$('[data-cart-drawer] [data-line-key]').find(row=>row.dataset.lineKey===lineKey);
const applyPendingQuantities=()=>{
  lineStates.forEach((state,lineKey)=>{
    const row=findLineRow(lineKey);if(!row)return;
    const stepper=$('[data-cart-quantity]',row),value=$('[data-cart-quantity-value]',row);
    if(value)value.textContent=String(state.desired);
    if(stepper)stepper.classList.add('is-updating');
    row.classList.toggle('is-removing',state.desired===0);
  });
};

const render=cart=>{
  $$('[data-cart-count]').forEach(e=>{e.textContent=cart.item_count;e.hidden=!cart.item_count});
  const d=$('[data-cart-drawer]');if(!d)return;
  const empty=$('[data-cart-empty]',d),lines=$('[data-cart-lines]',d),foot=$('[data-cart-footer]',d),sub=$('[data-cart-subtotal]',d),limit=Number(d.dataset.freeShippingThreshold||0)*100,bar=$('[data-shipping-progress]',d),txt=$('[data-shipping-text]',d);
  if(bar)bar.style.setProperty('--progress',`${limit?Math.min(100,cart.total_price/limit*100):100}%`);
  if(txt)txt.textContent=!limit||cart.total_price>=limit?'You unlocked free shipping.':`Add ${money(limit-cart.total_price)} more for free shipping.`;
  if(sub)sub.textContent=money(cart.total_price);
  if(empty)empty.hidden=cart.item_count>0;
  if(foot)foot.hidden=cart.item_count===0;
  if(!lines)return;
  lines.hidden=!cart.item_count;
  lines.innerHTML=cart.items.map(x=>`<div class="sd-cart-line" data-line-key="${esc(x.key)}"><a class="sd-cart-line__image" href="${esc(x.url)}">${x.image?`<img src="${esc(x.image)}${x.image.includes('?')?'&':'?'}width=220" alt="${esc(x.product_title)}" loading="lazy">`:''}</a><div><a class="sd-cart-line__title" href="${esc(x.url)}">${esc(x.product_title)}</a>${x.variant_title&&x.variant_title!=='Default Title'?`<div class="sd-cart-line__variant">${esc(x.variant_title)}</div>`:''}<div class="sd-cart-line__price">${money(x.final_line_price)}</div><div class="sd-cart-line__quantity" data-cart-quantity><button type="button" data-cart-delta="-1" aria-label="Decrease quantity">−</button><span data-cart-quantity-value aria-live="polite">${x.quantity}</span><button type="button" data-cart-delta="1" aria-label="Increase quantity">+</button></div></div><button class="sd-cart-line__remove" type="button" data-cart-remove="${esc(x.key)}">Remove</button></div>`).join('');
  applyPendingQuantities();
};

const cleanProperties=value=>Object.fromEntries(Object.entries(value||{}).filter(([,v])=>v!==null&&v!==undefined&&String(v)!=='').sort(([a],[b])=>a.localeCompare(b)));
const propertiesEqual=(a,b)=>JSON.stringify(cleanProperties(a))===JSON.stringify(cleanProperties(b));
const requestFromForm=form=>{
  const data=new FormData(form);
  const variantId=Number(data.get('id'));
  const quantity=Math.max(1,Number.parseInt(String(data.get('quantity')||'1'),10)||1);
  const properties={};
  for(const[name,value]of data.entries()){
    const match=/^properties\[(.+)]$/.exec(name);
    if(match&&String(value)!=='')properties[match[1]]=String(value);
  }
  return{data,variantId,quantity,properties,sellingPlan:String(data.get('selling_plan')||'')};
};
const itemSellingPlan=item=>String(item.selling_plan_allocation?.selling_plan?.id||'');
const matchingLine=(cart,request)=>cart.items.find(item=>Number(item.variant_id)===request.variantId&&propertiesEqual(item.properties,request.properties)&&itemSellingPlan(item)===request.sellingPlan);

const setExistingLine=async(lineKey,quantity)=>{
  const r=await fetch(R.cartChange||'/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json',Accept:'application/json'},
    body:JSON.stringify({id:lineKey,quantity})
  });
  const j=await r.json();
  if(!r.ok)throw Error(j.description||'Cart quantity could not be updated.');
  return j;
};

const addNewLine=async request=>{
  request.data.set('quantity',String(request.quantity));
  const r=await fetch(R.cartAdd||'/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:request.data});
  const j=await r.json();
  if(!r.ok)throw Error(j.description||'Please choose an available size.');
  return fetchCart();
};

const add=async form=>{
  const btn=$('[data-add-to-cart]',form),msg=$('[data-product-message]',form);
  if(btn?.disabled||form.dataset.sdCartBusy==='1')return;
  const chips=$$('[data-card-variant]',form);
  if(chips.length&&!chips.some(x=>x.classList.contains('is-selected'))){toast('Please select a size.');return}
  const request=requestFromForm(form);
  if(!request.variantId){toast('Please select an available size.');return}
  form.dataset.sdCartBusy='1';
  if(btn){btn.disabled=true;btn.classList.add('is-loading')}
  try{
    const before=await fetchCart();
    const existing=matchingLine(before,request);
    const cart=existing?await setExistingLine(existing.key,existing.quantity+request.quantity):await addNewLine(request);
    render(cart);
    openDrawer('cart');
    toast(existing?'Cart quantity updated':'Added to cart');
  }catch(e){
    const t=e.message||'Could not add this product to cart.';
    if(msg){msg.textContent=t;msg.classList.add('is-visible')}
    toast(t);
  }finally{
    delete form.dataset.sdCartBusy;
    const root=form.closest('[data-product-root]'),v=root&&C.chosen?.(root);
    if(btn){btn.disabled=v?!v.available:false;btn.classList.remove('is-loading')}
  }
};

const flushLine=async lineKey=>{
  const state=lineStates.get(lineKey);
  if(!state||state.inFlight)return;
  state.inFlight=true;
  state.timer=null;
  const sentQuantity=state.desired;
  try{
    const cart=await setExistingLine(lineKey,sentQuantity);
    const latest=lineStates.get(lineKey);
    if(!latest)return;
    latest.inFlight=false;
    if(latest.desired!==sentQuantity){latest.timer=setTimeout(()=>flushLine(lineKey),35);return}
    lineStates.delete(lineKey);
    render(cart);
  }catch(e){
    lineStates.delete(lineKey);
    toast(e.message||'Cart could not be updated.');
    try{render(await fetchCart())}catch(_){ }
  }
};

const queueLineQuantity=(lineKey,nextQuantity,row,immediate=false)=>{
  if(!lineKey)return;
  const safeQuantity=Math.max(0,Number(nextQuantity)||0);
  let state=lineStates.get(lineKey);
  if(!state){state={desired:safeQuantity,inFlight:false,timer:null};lineStates.set(lineKey,state)}
  state.desired=safeQuantity;
  if(state.timer)clearTimeout(state.timer);
  if(row){
    const stepper=$('[data-cart-quantity]',row),value=$('[data-cart-quantity-value]',row);
    if(value)value.textContent=String(safeQuantity);
    if(stepper)stepper.classList.add('is-updating');
    row.classList.toggle('is-removing',safeQuantity===0);
  }
  if(!state.inFlight)state.timer=setTimeout(()=>flushLine(lineKey),immediate?0:75);
};

const stepQuantity=button=>{
  const row=button.closest('[data-line-key]'),stepper=button.closest('[data-cart-quantity]');
  const value=stepper&&$('[data-cart-quantity-value]',stepper),lineKey=row?.dataset.lineKey;
  if(!row||!value||!lineKey)return;
  const existing=lineStates.get(lineKey);
  const current=existing?existing.desired:Number.parseInt(value.textContent||'0',10)||0;
  const next=Math.max(0,current+(Number(button.dataset.cartDelta)||0));
  if(next===current)return;
  queueLineQuantity(lineKey,next,row,false);
};

const removeLine=button=>{
  const row=button.closest('[data-line-key]'),lineKey=button.dataset.cartRemove||row?.dataset.lineKey;
  if(!lineKey)return;
  queueLineQuantity(lineKey,0,row,true);
};

document.addEventListener('submit',e=>{
  const pin=e.target.closest('[data-pincode-form]');
  if(pin){
    e.preventDefault();e.stopImmediatePropagation();
    const input=$('input',pin),out=$('[data-pincode-result]',pin.closest('.sd-delivery'));
    if(out)out.textContent=/^\d{6}$/.test(input?.value.trim()||'')?'Delivery is usually 3–7 business days. COD availability is confirmed at checkout.':'Enter a valid 6-digit Indian pincode.';
    return;
  }
  const f=e.target.closest('[data-product-form]');if(!f)return;
  const s=e.submitter;
  if(s?.closest('.shopify-payment-button')||s?.classList.contains('shopify-payment-button__button'))return;
  e.preventDefault();e.stopImmediatePropagation();add(f);
},true);

document.addEventListener('click',e=>{
  const size=e.target.closest('[data-card-variant]');
  if(size){
    e.preventDefault();e.stopImmediatePropagation();
    const f=size.closest('form');$$('[data-card-variant]',f).forEach(x=>x.classList.remove('is-selected'));
    size.classList.add('is-selected');const input=$('[data-card-variant-input]',f);if(input)input.value=size.dataset.cardVariant;
    const t=$('[data-add-to-cart] span',f);if(t)t.textContent='ADD TO CART';return;
  }
  const step=e.target.closest('[data-cart-delta]');if(step){e.preventDefault();e.stopImmediatePropagation();stepQuantity(step);return}
  const remove=e.target.closest('[data-cart-remove]');if(remove){e.preventDefault();e.stopImmediatePropagation();removeLine(remove);return}
  const close=e.target.closest('[data-drawer-close]');if(close){e.preventDefault();e.stopImmediatePropagation();drawer(close.closest('[data-drawer-name]'),false);return}
  const cart=e.target.closest('[data-open-cart]');if(cart){e.preventDefault();e.stopImmediatePropagation();openDrawer('cart');return}
  const search=e.target.closest('[data-open-search]');if(search){e.preventDefault();e.stopImmediatePropagation();openDrawer('search');return}
  const menu=e.target.closest('[data-open-mobile-menu]');if(menu){e.preventDefault();e.stopImmediatePropagation();openDrawer('mobile-menu');return}
},true);

document.addEventListener('keydown',e=>{if(e.key==='Escape')$$('[data-drawer-name].is-open').forEach(x=>drawer(x,false))});
C.fetchCart=fetchCart;C.renderCart=render;C.initCart=async()=>{try{render(await fetchCart())}catch(_){}};
})();
